export const SESSION_GATE_KEY = "academySessionAcknowledged";
export const BROWSER_SESSION_INSTANCE_KEY = "academyBrowserSessionInstance";

function createBrowserSessionInstanceId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function markSessionAcknowledged() {
  const instanceId = createBrowserSessionInstanceId();
  try {
    sessionStorage.setItem(SESSION_GATE_KEY, "1");
    sessionStorage.setItem(BROWSER_SESSION_INSTANCE_KEY, instanceId);
    localStorage.setItem(BROWSER_SESSION_INSTANCE_KEY, instanceId);
  } catch {
    /* ignore */
  }
}

export function clearSessionAcknowledged() {
  try {
    sessionStorage.removeItem(SESSION_GATE_KEY);
    sessionStorage.removeItem(BROWSER_SESSION_INSTANCE_KEY);
    localStorage.removeItem(BROWSER_SESSION_INSTANCE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSessionAcknowledged() {
  try {
    if (sessionStorage.getItem(SESSION_GATE_KEY) !== "1") {
      return false;
    }
    const tabInstance = sessionStorage.getItem(BROWSER_SESSION_INSTANCE_KEY);
    const browserInstance = localStorage.getItem(BROWSER_SESSION_INSTANCE_KEY);
    return Boolean(tabInstance && browserInstance && tabInstance === browserInstance);
  } catch {
    return false;
  }
}
